import React, { useState } from 'react';
import { Box, Button, MenuItem, TextField, Typography } from '@mui/material';
import { LANGUAGE_NAMES } from '../constants/languages';

function BatchTranslationForm({ languages, onBatchTranslate }) {
    const [inputText, setInputText] = useState('');
    const [sourceLanguage, setSourceLanguage] = useState(languages[0]);
    const [targetLanguage, setTargetLanguage] = useState(languages[1]);

    const handleTranslate = async () => {
        if (!inputText.trim()) {
            alert('Please enter some text to translate.');
            return;
        }

        if (sourceLanguage === targetLanguage) {
            alert('Please choose two different languages.');
            return;
        }

        try {
            await onBatchTranslate({ inputText, sourceLanguage, targetLanguage });
        } catch (error) {
            console.error('Error during translation:', error);
            alert('Failed to process the translation. Please try again.');
        }
    };

    return (
        <Box>
            <Typography variant="h6" fontWeight={700} sx={{ mb: 1.5 }}>
                Batch translation
            </Typography>

            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: { xs: '1fr', md: 'minmax(0, 1fr) 180px 180px' },
                    gap: 1.5,
                    alignItems: 'start',
                }}
            >
                <TextField
                    label="Ingredients or terms"
                    placeholder="Comma-separated terms"
                    fullWidth
                    multiline
                    minRows={3}
                    value={inputText}
                    onChange={(e) => setInputText(e.target.value)}
                />

                <TextField
                    select
                    size="small"
                    label="From"
                    value={sourceLanguage}
                    onChange={(e) => setSourceLanguage(e.target.value)}
                >
                    {languages.map((lang) => (
                        <MenuItem key={lang} value={lang}>
                            {LANGUAGE_NAMES[lang] || lang.toUpperCase()}
                        </MenuItem>
                    ))}
                </TextField>

                <TextField
                    select
                    size="small"
                    label="To"
                    value={targetLanguage}
                    onChange={(e) => setTargetLanguage(e.target.value)}
                >
                    {languages.map((lang) => (
                        <MenuItem key={lang} value={lang}>
                            {LANGUAGE_NAMES[lang] || lang.toUpperCase()}
                        </MenuItem>
                    ))}
                </TextField>
            </Box>

            <Button variant="contained" onClick={handleTranslate} sx={{ mt: 1.5 }}>
                Translate
            </Button>
        </Box>
    );
}

export default BatchTranslationForm;
